<div class="uploads-page">
  <div class="header">
    <div class="title">{{ title }}</div>
  </div>
  <progress-spinner *ngIf="isLoading"></progress-spinner>
  <mat-tab-group class="uploads-tab-group" (selectedTabChange)="changeTab($event)">
    <mat-tab label="Agent Images">
      <div class="images-tab-content">
        <div class="uploade-section">
          <mat-card>
            <progress-spinner *ngIf="isLoading"></progress-spinner>
            <div class="section-label"><i class="mdi mdi-file"></i> Upload Images</div>
            <div class="group repeat-DD">
              <div class="label">Agent Type</div>
              <mat-select
                class="option-list"
                #agentTypeInput="ngModel"
                [(ngModel)]="selectedAgentType"
                name="agentType"
                (selectionChange)="onAgentTypeChange($event)"
                required
              >
                <mat-option *ngFor="let agent of uploadAgentType" [value]="agent.value">{{
                  agent.name
                }}</mat-option>
              </mat-select>
            </div>
            <div class="group">
              <div class="label">Choose Image</div>
              <div class="file-upload-container">
                <input
                  class="file-upload-input"
                  placeholder="Select file"
                  [value]="selectedFileName"
                  (click)="file.click()"
                />
                <input
                  #file
                  [accept]="fileAccept"
                  type="file"
                  (change)="onFileSelected($event)"
                  style="display: none"
                />
                <i
                  (click)="clearSelectedFile()"
                  *ngIf="showClearButton"
                  class="close-icon mdi mdi-close"
                ></i>
                <button class="input-btn btn-blue" *ngIf="!showClearButton" (click)="file.click()">
                  <i class="icon mdi mdi-folder-open"></i>
                </button>
                <button
                  class="input-btn btn-blue"
                  *ngIf="showClearButton"
                  (click)="uploadImages()"
                  [disabled]="!selectedFileName || isValidAgentFileExtension"
                >
                  <i class="icon mdi mdi-check"></i>
                </button>
              </div>
              <div *ngIf="isValidAgentFileExtension" class="error-msg">Invalid file extension.</div>
            </div>
          </mat-card>
        </div>

        <div class="images-list-wrapper" *ngIf="table && table.columns && table.columns.length > 0">
          <div class="datasource-content" class="content-width-100">
            <mat-card class="agent-data">
              <ng-template #action>
                <ng-container class="headline-action-button">
                  <button
                    [matMenuTriggerFor]="menu"
                    mat-button
                    class="action-button"
                    aria-label="Open menu"
                  >
                    <span
                      class="mat-button-wrapper"
                      matTooltip="Different type of agent can't be upgraded."
                      [matTooltipDisabled]="!isActionsDisabled || isActionsShowable"
                      ><i class="material-icons">more_horiz</i></span
                    >
                  </button>
                  <mat-menu #menu="matMenu">
                    <button
                      class="mat-menu-item-btn"
                      mat-menu-item
                      (click)="removeVersion(selectedRowData)"
                    >
                      <span>Remove</span>
                    </button>
                    <button
                      class="mat-menu-item-btn"
                      mat-menu-item
                      (click)="downloadAgentImage(selectedRowData)"
                    >
                      <span>Download</span>
                    </button>
                  </mat-menu>
                </ng-container>
              </ng-template>
              <div class="images-table">
                <viavi-table
                  [tableConfigurations]="table"
                  [isActionEnabled]="isCheckBoxEnabled"
                  [template]="action"
                  (sendRowAction)="onActionClick($event)"
                  [showToolbar]="false"
                ></viavi-table>
              </div>
            </mat-card>
          </div>
        </div>
        <!-- <div class="no-results" *ngIf="!hasData() && !isLoading">No records found</div> -->
      </div>
    </mat-tab>
    <mat-tab label="JMEP Activation Keys">
      <div class="images-tab-content">
        <div class="uploade-section">
          <mat-card>
            <progress-spinner *ngIf="isLoading"></progress-spinner>
            <div class="section-label"><i class="mdi mdi-key size20"></i> JMEP Activation Keys</div>
            <div class="section-info">
              <div class="file-info">
                <div class="section-label-1" *ngIf="jmepKeysFileName">
                  <label>Name: </label> {{ jmepKeysFileName }}
                </div>
                <div class="section-label-1" *ngIf="jmepKeysFileDateString">
                  <label>Last Uploaded: </label> {{ jmepKeysFileDateString }}
                </div>
              </div>
              <div
                class="agent-button"
                (click)="redistributeJMEPKeys()"
                matTooltip="Redistribute uploaded keys file to all ESAM devices"
              >
                <i class="icon mdi mdi-refresh"></i>
                <span class="name">Redistribute Keys</span>
              </div>
            </div>

            <div class="group">
              <div class="label">Choose JMEP Activation Keys File</div>
              <div class="file-upload-container">
                <input
                  class="file-upload-input"
                  placeholder="Select file"
                  [value]="selectedFileName"
                  (click)="file.click()"
                />
                <input
                  #file
                  [accept]="fileAccept"
                  type="file"
                  (change)="onFileSelected($event)"
                  style="display: none"
                />
                <i
                  (click)="clearSelectedFile()"
                  *ngIf="showClearButton"
                  class="close-icon mdi mdi-close"
                ></i>
                <button class="input-btn btn-blue" *ngIf="!showClearButton" (click)="file.click()">
                  <i class="icon mdi mdi-folder-open"></i>
                </button>
                <button
                  class="input-btn btn-blue"
                  *ngIf="showClearButton"
                  (click)="uploadJmepActivationKeys()"
                  [disabled]="!selectedFileName || isValidAgentFileExtension"
                >
                  <i class="icon mdi mdi-check"></i>
                </button>
              </div>
              <div *ngIf="isValidAgentFileExtension" class="error-msg">Invalid file extension.</div>
            </div>
          </mat-card>
        </div>

        <!-- <div class="no-results" *ngIf="!hasData() && !isLoading">No records found</div> -->
      </div>
    </mat-tab>
    <mat-tab label="JMEP Field Mapping">
      <div class="images-tab-content">
        <div class="uploade-section">
          <mat-card>
            <progress-spinner *ngIf="isLoading"></progress-spinner>
            <div class="section-label"><i class="mdi mdi-file"></i> JMEP Field Mapping File</div>

            <div class="group">
              <div class="label">Choose JMEP Field Mapping File(CSV)</div>
              <div class="file-upload-container">
                <input
                  class="file-upload-input"
                  placeholder="Select file"
                  [value]="selectedFileName"
                  (click)="file.click()"
                />
                <input
                  #file
                  [accept]="fileAccept"
                  type="file"
                  (change)="onFileSelected($event)"
                  style="display: none"
                />
                <i
                  (click)="clearSelectedFile()"
                  *ngIf="showClearButton"
                  class="close-icon mdi mdi-close"
                ></i>
                <button class="input-btn btn-blue" *ngIf="!showClearButton" (click)="file.click()">
                  <i class="icon mdi mdi-folder-open"></i>
                </button>
                <button
                  class="input-btn btn-blue"
                  *ngIf="showClearButton"
                  (click)="uploadJmepFieldMapping()"
                  [disabled]="!selectedFileName || isValidAgentFileExtension"
                >
                  <i class="icon mdi mdi-check"></i>
                </button>
              </div>
              <div *ngIf="isValidAgentFileExtension" class="error-msg">Invalid file extension.</div>
            </div>
          </mat-card>
        </div>

        <div
          class="images-list-wrapper"
          *ngIf="mappingTable && mappingTable.columns && mappingTable.columns.length > 0"
        >
          <div class="datasource-content" class="content-width-100">
            <mat-card class="agent-data">
              <ng-template #action>
                <ng-container class="headline-action-button">
                  <button
                    [matMenuTriggerFor]="menu"
                    mat-button
                    class="action-button"
                    aria-label="Open menu"
                  >
                    <span
                      class="mat-button-wrapper"
                      matTooltip="Different type of agent can't be upgraded."
                      [matTooltipDisabled]="!isActionsDisabled || isActionsShowable"
                      ><i class="material-icons">more_horiz</i></span
                    >
                  </button>
                  <mat-menu #menu="matMenu">
                    <button
                      class="mat-menu-item-btn"
                      mat-menu-item
                      (click)="onActionFieldMappingClick({ label: 'apply', data: selectedRowData })"
                    >
                      <span>Apply</span>
                    </button>
                    <button
                      class="mat-menu-item-btn"
                      mat-menu-item
                      (click)="
                        onActionFieldMappingClick({ label: 'download', data: selectedRowData })
                      "
                    >
                      <span>Download Input File</span>
                    </button>
                    <button
                      class="mat-menu-item-btn"
                      mat-menu-item
                      (click)="
                        onActionFieldMappingClick({ label: 'remove', data: selectedRowData })
                      "
                    >
                      <span>Remove</span>
                    </button>
                    <button
                      class="mat-menu-item-btn"
                      mat-menu-item
                      (click)="
                        onActionFieldMappingClick({ label: 'results', data: selectedRowData })
                      "
                    >
                      <span>View Last Results</span>
                    </button>
                  </mat-menu>
                </ng-container>
              </ng-template>
              <div class="images-table">
                <viavi-table
                  [tableConfigurations]="mappingTable"
                  [isActionEnabled]="isCheckBoxEnabled"
                  [template]="action"
                  (sendRowAction)="onActionFieldMappingClick($event)"
                  [showToolbar]="false"
                ></viavi-table>
              </div>
            </mat-card>
          </div>
        </div>
        <!-- <div class="no-results" *ngIf="!hasData() && !isLoading">No records found</div> -->
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
